import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatHintQuestionsActionTypes {
  Hide = 'chat/hintQuestions/hide',
}

export type TChatHintQuestionsPayload = {
  chatId: string;
};

export type TChatHintQuestionsActions = ITypedReduxAction<
  EChatHintQuestionsActionTypes.Hide,
  TChatHintQuestionsPayload
>;
